import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { ApiPropertyOptions } from '@nestjs/swagger/dist/decorators/api-property.decorator';
import { Type } from 'class-transformer';
import { isDefined, IsNumber, IsOptional, Max, Min } from 'class-validator';
import { FIELD_INVALID_NUMBER, INVALID_LIMIT_VALUE } from '../constants';
import { BaseDecoratorOptions } from '../types';

type PropertyFloatParams = {
  each?: boolean;
  maxDecimalPlaces?: number;
  min?: number;
  max?: number;
} & BaseDecoratorOptions<number | number[]>;

export function ApiPropertyFloat({
  isOptional,
  each,
  maxDecimalPlaces,
  min,
  max,
  ...options
}: PropertyFloatParams = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = {
    type: Number,
    example: each ? [1, 2.1, 3.2] : 2.1,
    isArray: each,
    ...(min ? { minimum: min } : {}),
    ...(max ? { maximum: max } : {}),
    ...options,
  };

  const decimalPlaces = { ...(isDefined(maxDecimalPlaces) && { maxDecimalPlaces }) };
  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsNumber({ ...decimalPlaces }, { message: FIELD_INVALID_NUMBER, each, context: { ...decimalPlaces } }),
    Type(() => Number),
    ...(!isNaN(min!) ? [Min(min!, { message: INVALID_LIMIT_VALUE, context: { minValue: min }, each })] : []),
    ...(!isNaN(max!) ? [Max(max!, { message: INVALID_LIMIT_VALUE, context: { maxValue: max }, each })] : []),
  );
}
